module.exports = __webpack_public_path__ + "static/media/etnoselo.731b5c32.png";